/* eslint-disable no-useless-catch */
import apiZelo from '../backAxiosVendaToken';

export const buscaUsrPermissaoUpSell = async values => {
    try {
        const vendedor = await apiZelo.post('/upsell/usuarios', values);

        return vendedor.data;
    } catch (error) {
        return error;
    }
};

export const buscarContratoUpSellPorInscricao = async (codigo, tipo, inscricao) => {
    try {
        const baseUrl = `/upsell/contratos/${inscricao}?codigo=${codigo}&tipo=${tipo}`;

        return await apiZelo.get(baseUrl);
    } catch (error) {
        return error;
    }
};

export const buscarContratoUpsellPorVendedor = async (tipoColaborador, codigoVendedor) => {
    try {
        const baseUrl = '/upsell/contratos';
        const url = `${baseUrl}?codigo=${codigoVendedor}&tipo=${tipoColaborador} `;

        return await apiZelo.get(url);
    } catch (error) {
        return error;
    }
};

export const buscarPlanosPassiveisUpSell = async (cidade, cod, areaAtuacao) => {
    try {
        const url = `upsell/planos?codigoIbge=${cidade}&plano=${cod}&areaAtuacao=${areaAtuacao}`;

        return await apiZelo.get(url);
    } catch (error) {
        return error;
    }
};

export const verificarPlanosElegiveis = async (codigoIbge, plano, areaAtuacao, inscricao) => {
    try {
        const url = `upsell/planos?codigoIbge=${codigoIbge}&plano=${plano}&areaAtuacao=${areaAtuacao}&inscricao=${inscricao}`;

        return await apiZelo.get(url);
    } catch (error) {
        return error;
    }
};

export const atuatualizarLogUpSell = async (dadosVendedor, body) => {
    try {
        return await apiZelo.patch(`/upsell/contratos/${dadosVendedor.inscricao}?tipo=${dadosVendedor.tipo}&codigo=${dadosVendedor.codigo}`, body);
    } catch (error) {
        return error;
    }
};

export const cadastrarLogUpSell = async values => {
    try {
        return await apiZelo.post(`/upsell/contratos/${values.inscricao}?tipo=${values.tipo}&codigo=${values.codigo}`);
    } catch (error) {
        return error;
    }
};

export const buscarAssociadoUpSell = async inscricao => {
    const response = await apiZelo.get(`upsell/associados/${inscricao}`);

    return response.data;
};

export const atuatualizarAssociadoUpSell = async (inscricao, values) => {
    try {
        return await apiZelo.patch(`/upsell/associados/${inscricao}`, values);
    } catch (error) {
        return error;
    }
};

export const buscarDadosComparacaoUpSell = async inscricao => {
    const response = await apiZelo.get(`upsell/contratos/${inscricao}/diff`);

    return response.data;
};

export const buscarDadosComparacaoPlanoMigrado = async inscricao => {
    const response = await apiZelo.get(`upsell/contratos/${inscricao}/pos`);

    return response.data;
};

export const enviarAceiteUpSell = async (dadosVendedor, body) => {
    try {
        const response = await apiZelo.post(`/upsell/contratos/${dadosVendedor.inscricao}/aceite/?tipo=${dadosVendedor.tipo}&codigo=${dadosVendedor.codigo}`, body);

        return response;
    } catch (error) {
        if (error.response) {
            return error.response;
        } else {
            throw error;
        }
    }
};
